import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";

export async function initNativeShell() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: true });
    await StatusBar.setStyle({ style: Style.Light });
  } catch (e) {
    console.warn("StatusBar init failed", e);
  }
  try {
    await SplashScreen.hide();
  } catch (e) {
    console.warn("Splash hide failed", e);
  }
}

export const isNative = () => Capacitor.isNativePlatform();
